import React, {Fragment} from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Mantenedor from "../admin-concursos/Mantenedor";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from '@material-ui/icons/Edit';
import {handleConcursosDetailError} from "../../utils/errors";

const useStyles = makeStyles((theme) => ({
    dialog: {
        "& .MuiDialog-paper": {
            maxWidth: "700px",
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    tooltip: {
        fontSize: "14px",
        fontWeight: "normal",
    },
}));

export default function EditConcursoModal(props) {
    const [open, setOpen] = React.useState(false);
    const [data, setData] = React.useState({});
    const [openSpinner, setOpenSpinner] = React.useState(false);
    const classes = useStyles();

    const handleError = (error) => {
        setOpen(false);
        setOpenSpinner(false);
        handleConcursosDetailError(error)
    }

    const handleOpen = () => {
        setOpenSpinner(true);
        axios
            .get(`${window.ENV.API_URL}/concursosBorrador/${props.concursoId}/`)
            .then((res) => {
                setData(res.data);
                setOpen(true);
                setOpenSpinner(false);
            })
            .catch((error) => handleError(error));
    };

    return (
        <Fragment>
            {/*<Button onClick={handleOpen}>{props.label}</Button>*/}
            <Tooltip
                onClick={handleOpen}
                title={<span className={classes.tooltip}>{props.label}</span>}
            >
                <IconButton>
                    <EditIcon/>
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                scroll={"paper"}
                className={classes.dialog}
                fullWidth
            >
                <Mantenedor
                    handleModal={() => setOpen(false)}
                    concursoId={props.concursoId}
                    title={"Editar concurso"}
                    saveDraft={true}
                    defaultData={data}
                    disableOnInvalid={true}
                    sitio={props.sitio}
                />
            </Dialog>
            <Backdrop className={classes.backdrop} open={openSpinner}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        </Fragment>
    );
}
